import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    padding: "0px",
    margin: "0px",
    position: "relative",
    "& .MuiInputAdornment-root": {
      color: "red",
      marginTop: "2px",
    },
    "& .MuiTypography-colorTextSecondary": {
      color: "#212934",
      marginTop: "1px",
    },
  },
  input: {
    letterSpacing: "0.2px",
    lineHeight: "22px",
    "& .MuiInputBase-input": {
      "&::placeholder": {
        color: "#B8C4CE",
        opacity: "1",
      },
      textAlign: "right",
      padding: "0",
      fontWeight: "600",
      color: "#212934",
    },

    fontFamily: "Source Sans Pro",
    fontSize: "18px",
  },
  inputContent: {
    fontWeight: "600",
    color: "#212934",
    lineHeight: "22px",
    position: "absolute",
    top: "0",
    right: "0",
    letterSpacing: "0.2px",
  },
  hiddenContent: {
    opacity: '0',
    visibility: '0',
    color: 'transparent',
  },
  signPlaceholder: {
    marginRight: '9px',
    color: "#B8C4CE",
  },
  sign: {
    fontWeight: "600",
    color: "#212934",
  }
}));

function EditableInput(props) {
  const classes = useStyles();

  const filterValues = (e) => {
    const numbers = "0123456789";
    const keyboardActions = ["ArrowRight", "ArrowLeft", "Backspace"];
    if (
      !numbers.includes(e.key.toLowerCase()) &&
      !keyboardActions.includes(e.key)
    ) {
      return e.preventDefault();
    }
  };

  return (
    <div className={classes.root}>

      {props.showDollarSign && (
        <div className={classes.inputContent}>
          {props.value
            ? <span>$</span>
            : <span className={classes.signPlaceholder}>$</span>
          }
          <span className={classes.hiddenContent}>{props.value}</span>
        </div>
      )}

      <InputBase
        onChange={props.onChange}
        className={classes.input}
        type="text"
        onKeyDown={filterValues}
        inputProps={props.inputProps}
        value={props.value}
        placeholder={props.placeholder.toString()}
        style={props.showPercentSign ? {paddingRight: '4px'} : {}}
        inputProps={props.inputProps}
      />

      {props.showPercentSign && (
        <span className={classes.sign}>%</span>
      )}

    </div>
  );
}

export default EditableInput;
